export const SET_DEFAULT_REDIRECT_URL = "SET_DEFAULT_REDIRECT_URL";
export const SET_CLAIM_CODE = "SET_CLAIM_CODE";
